<template>
  <div>
    <customer-payment-receipt-file
        v-if="(order.payment.method === 'BANK_TRANSFER' || order.payment.method === 'MP_TRANSFER') && order.payment.receiptFile === null"
        :order="order"
        @orderModified="onOrderModified"
    />
    <order-payment v-else :order="order" :total-amount="order.totalAmount" vertical></order-payment>

  </div>
</template>

<script>
import OrderPayment from "@/modules/delivery/components-core/shared/OrderPayment/OrderPayment.vue";
import CustomerPaymentReceiptFile from "@/modules/delivery/components-core/customer/CustomerPaymentReceiptFile/CustomerPaymentReceiptFile.vue";

export default {
  name: "ShowOrderPayment",
  components: {CustomerPaymentReceiptFile, OrderPayment},
  props: {
    order: {type: Object}
  },
  methods: {
    onOrderModified(order){
      this.$emit('orderModified',order)
    }
  }
}
</script>

<style scoped>

</style>
